export const shopLanguageOptions: { value: string, label: string }[] = [
    { label: 'English', value: 'en' },
    { label: 'French', value: 'fr' },
    { label: 'Danish', value: 'da' },
    { label: 'Deutsch', value: 'de' },
    { label: 'Finnish', value: 'fi' },
    { label: 'Italian', value: 'it' },
    { label: 'Spanish', value: 'es' },
    { label: 'Swedish', value: 'sv' },
    { label: 'Norwegian', value: 'no' },
    { label: 'Polish', value: 'pl' },
    { label: 'Portuguese', value: 'pt' },
    { label: 'Japanese', value: 'ja' },
    { label: 'Chinese', value: 'zh-CN' },
]
